exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".lang--col--2mQSp0HM {\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.lang--row--7lPp1q3- {\r\n  margin-top: 16px;\r\n}\r\n.lang--headers--1Ad_jy1t {\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: #5B6770;\r\n}\r\n\r\n.lang--addColMargin--KL7JSt05{\r\n  margin-top: 15px;\r\n}\r\n", "", {"version":3,"sources":["D:/dev-projects/SkillSmart/seeker-wib1/SeekerV2/src/components/profile/langEditor/lang.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;CACtB;;AAED;EACE,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;CAChB;;AAED;EACE,iBAAiB;CAClB","file":"lang.css","sourcesContent":[".col {\r\n  padding-bottom: 15px;\r\n}\r\n\r\n.row {\r\n  margin-top: 16px;\r\n}\r\n.headers {\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: #5B6770;\r\n}\r\n\r\n.addColMargin{\r\n  margin-top: 15px;\r\n}\r\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"col": "lang--col--2mQSp0HM",
	"row": "lang--row--7lPp1q3-",
	"headers": "lang--headers--1Ad_jy1t",
	"addColMargin": "lang--addColMargin--KL7JSt05"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./src/components/profile/langEditor/lang.css
// module id = 411
// module chunks = 0